import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../../Components/consts'

export const GameRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  borderBottom: `solid 1px ${colors.lightestGrey}`,
  padding: theme.spacing(1),
  '& .gameCol': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& .dateRow': {
      margin: theme.spacing(1),
      color: colors.helperText,
      fontWeight: 700,
      fontSize: fontSizes.medium,
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
      },
    },
  },
}))

export const ScoresRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-around',
  margin: theme.spacing(1, 0),
  '& a': {
    textDecoration: 'none',
  },
  '& .gameCol': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& .gameTime': {
      fontSize: fontSizes.medium,
      fontWeight: 'bold',
      color: colors.helperText,
      margin: theme.spacing(2, 0),
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
        margin: theme.spacing(1),
      },
    },
    '& .live': {
      fontSize: fontSizes.medium,
      fontWeight: 'bold',
      color: colors.green,
      margin: theme.spacing(1, 0),
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
        margin: theme.spacing(1),
      },
    },
    '& .statusText': {
      fontSize: fontSizes.medium,
      fontWeight: 'bold',
      color: colors.helperText,
      margin: theme.spacing(2, 0),
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
        margin: theme.spacing(1),
      },
    },
  },
}))

export const TeamScoresCol = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: 300,
  [theme.breakpoints.down('sm')]: {
    width: 120,
  },
  '& .score': {
    fontSize: fontSizes.large,
    fontWeight: 900,
    color: colors.text,
  },
  '& img': {
    height: 50,
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      height: 30,
    },
  },
  '& .name': {
    margin: theme.spacing(1),
    fontSize: fontSizes.medium,
    fontWeight: 700,
    color: colors.helperText,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .record': {
    fontSize: fontSizes.small,
    fontWeight: 500,
    color: colors.helperText,
  },
}))